import { page, pageVisible, loading } from '../../../WebGiving/main/webgiving-main.less';
import { classNames } from '../../../Shared/utils/classnames';

export function getPageClasses(pageShouldBeVisible: boolean, isLoading: boolean) {
	return classNames(page, {
		[pageVisible]: pageShouldBeVisible,
		[loading]: isLoading,
	});
}
